// ** React Imports
import { Fragment } from 'react'

// ** Custom Components
import NavbarUser from './NavbarUser'
import NavbarBookmarks from './NavbarBookmarks'

import KathokLogo from '@src/assets/images/logo/logo-kathok.png'

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props

  return (
    <Fragment>
      <div className="d-flex d-xl-block align-items-center justify-content-between w-100">
        <div className="bookmark-wrapper d-flex align-items-center justify-content-between w-100 d-xl-inline-flex">
          <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
          <div className="d-flex align-items-center d-xl-none" style={{ marginLeft: '10px' }}>
            <img
              src={KathokLogo}
              style={{
                height: '30px'
              }}
            />
            <h6
              style={{
                color: 'white',
                marginLeft: '10px',
                marginBottom: 0
              }}
            >
              Kathok Membership
            </h6>
          </div>
        </div>
        <div className="d-none d-xl-block">
          <NavbarUser skin={skin} setSkin={setSkin} />
        </div>
      </div>
    </Fragment>
  )
}

export default ThemeNavbar
